<template>
  <el-container class="doc" direction='vertical'>
    <div class="search-container">
      <div class="v-search-btn">
        <el-input v-model="value" clearable placeholder="请输入用户ID/手机号"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="clickSearch" size="medium">查询</el-button>
        <div class="custom-container">
          <span>自定义充值金额：</span>
          <el-input type="number" @keydown.native="channelInputLimit" v-model="customValue" clearable placeholder="请输入自定义充值金额"></el-input>
        </div>
      </div>
    </div>
    <el-container direction='vertical' class="mian-container" v-if="shopRecharg.length">
      <div class="scrollbar-container ">
        <el-scrollbar>
          <div class="send-text-pc">{{shopRecharg[current].coupontext}}</div>
          <div class="cash-list-container">
            <el-row :gutter="60">
              <el-col v-for="(item,i) in shopRecharg" :key="i" :span="8">
                <el-card @click.native="clickCash(i)" shadow="always" :class="i === current ? 'active' :''"><span v-if="item.amount!=='（自定义）'">￥</span>{{fullAmount(item.amount)}}</el-card>
              </el-col>
            </el-row>
          </div>
          <div class="cash-info-container">
            <div>
              <template v-if="isShowInfo">
                <el-divider content-position="left">会员信息</el-divider>
                <span v-if="memberInfo.name !==''" style="margin-left:115px;" class="span-divider">姓名：{{memberInfo.name}}</span>
                <span v-else style="margin-left:115px;" class="span-divider">姓名：{{memberInfo.wxname}}</span>
                <span class="span-divider">ID：{{memberInfo.mid}}</span>
                <span class="span-divider">手机号：{{memberInfo.mobile}}</span>
                <el-checkbox style="margin-left:30px;" v-model="checked">确认充值会员信息</el-checkbox>
              </template>
              <el-divider content-position="left">付款方式</el-divider>
              <el-radio style="margin-left:115px;" class="span-divider" v-model="radio" label="1">现金</el-radio>
              <el-radio class="span-divider" v-model="radio" label="2">刷卡</el-radio>
              <el-radio class="span-divider" v-model="radio" label="3">其他</el-radio>
              <el-button type="primary" :disabled="!checked" @click="handleRechargeAffirm" style="margin-right:32px;" size="medium">确认充值</el-button>
              <el-divider content-position="right"></el-divider>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </el-container>
  </el-container>
</template>
<script>
import {
  searchMemberInfo,
  memberRecharge,
  getRechargeCouponList
} from '@/views/webpc/CashierDesk/CashRechargeApp/apis'
// const shopRechargGroup = {
//   gzahh: {
//     // cashData: [500, 1000, 2000, 3000, 5000, 10000, 20000, '（自定义）'],
//     cashData: [500, 1000, 3000, '（自定义）'],
//     sendData: [
//       '送煎堆1份',
//       '送五谷烩花胶1份',
//       '送指定红酒一支',
//       ''
//     ]
//   },
//   gzwyh: {
//     cashData: [500, 1000, 2000, 3000, 20000, '（自定义）'],
//     sendData: [
//       '送空心煎堆一份',
//       '送红枣糕半打',
//       '送浓汤花胶鸡汤例',
//       '送法国红酒一支',
//       '芝士伊面焗波龙一只（免服务费）',
//       ''
//     ]
//   },
//   zhfh: {
//     cashData: [500, 1000, 3000, 5000, 10000, '（自定义）'],
//     sendData: [
//       '送椰香姜汁糕1份',
//       '送美极虾1份',
//       '送清蒸龙趸鱼1条',
//       '送芝士伊面龙虾1只',
//       '送浓汤鸡煲翅1例',
//       ''
//     ]
//   },
//   hzhb: {
//     // cashData: [500, 1000, 2000, 3000, '（自定义）'],
//     cashData: [500, 1000, 2000, 3000, 5000, 10000, '（自定义）'],
//     // sendData: ['', '', '', '', '']
//     sendData: ['送100元现金券', '送200现金券', '送400现金券', '送600现金券', '送1000现金券', '送2000现金券', '']
//   },
//   fzth: {
//     cashData: [500, 1000, 2000, 3000, 5000, 10000, '（自定义）'],
//     sendData: [
//       '首次充值送蒜蓉开边虾1份',
//       '首次充值送蒜蓉开边虾1份',
//       '首次充值送蒜蓉开边虾1份',
//       '首次充值送蒜蓉开边虾1份',
//       '首次充值送蒜蓉开边虾1份',
//       '首次充值送蒜蓉开边虾1份',
//       ''
//     ]
//   },
//   szty: {
//     cashData: [2000, 3000, 5000, 10000, '（自定义）'],
//     sendData: ['', '', '', '', '']
//   },
//   test: {
//     cashData: [500, 1000, 2000, 3000, 5000, 10000, '（自定义）'],
//     sendData: ['', '', '', '', '', '', '']
//   }
// }
export default {
  data () {
    return {
      shopRecharg: [],
      // shopRecharg: {
      //   cashData: [],
      //   sendData: []
      // },
      current: 0,
      value: '',
      radio: '1',
      customValue: null,
      cashData: [500, 1000, 2000, 3000, 5000, 10000, 20000, '（自定义）'],
      checked: false,
      memberInfo: {},
      isShowInfo: false
    }
  },
  methods: {
    fullAmount (amount) {
      if (amount !== '（自定义）') {
        return parseInt(amount)
      } else {
        return amount
      }
    },
    clickCash (i) {
      this.current = i
    },
    clickSearch () {
      this.memberInfo = {}
      this.isShowInfo = false
      this.checked = false
      if (this.value === '') {
        this.$message({
          type: 'warning',
          message: '请输入用户ID/手机号'
        })
        return
      }
      let data = new FormData()
      data.append('keywords', this.value)
      searchMemberInfo(data).then((result) => {
        if (result) {
          if (result.data) {
            this.isShowInfo = true
            this.memberInfo = result.data
          } else {
            this.$confirm('查无数据，请确认输入信息是否正确！', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(() => {})
              .catch(() => {})
          }
        }
      })
    },
    // 充值
    handleRechargeAffirm () {
      this.$confirm('确认充值金额, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.getConfirmRecharge()
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    getConfirmRecharge () {
      let data = new FormData()
      data.append('mid', this.memberInfo.mid)
      data.append('rechargetype', this.radio)
      if (this.current === this.shopRecharg.length - 1) {
        if (
          this.customValue === '' ||
          this.customValue === null ||
          this.customValue < 0
        ) {
          this.$message({
            type: 'warning',
            message: '自定义金额不能为空或小于0'
          })
          return
        }
        data.append('amount', this.customValue)
      } else {
        data.append('amount', this.shopRecharg[this.current].amount)
      }
      memberRecharge(data).then((result) => {
        if (result) {
          this.$message({
            type: 'success',
            message: '充值成功!'
          })
        }
      })
    },
    channelInputLimit (e) {
      const key = e.key
      if (key === 'e' || key === '+' || key === '-') {
        e.returnValue = false
        return false
      }
      return true
    },
    requestRechargeCouponList () {
      getRechargeCouponList().then((result) => {
        if (result) {
          this.shopRecharg = [ ...result.data.list, {amount: '（自定义）', coupontext: ''} ]
        }
      })
    }
  },
  watch: {
    customValue: function (newVal, oldVal) {
      this.shopRecharg[this.shopRecharg.length - 1].amount =
        newVal + '（自定义）'
    }
  },
  mounted () {},
  created () {
    // let shop = window.location.hostname.split('.')[0]
    // if (shop === 'szty') {
    //   this.shopRecharg.cashData = [2000, 3000, 5000, 10000, '（自定义）']
    // }
    // this.shopRecharg = shopRechargGroup[shop]
    // if (!this.shopRecharg) {
    //   this.shopRecharg = shopRechargGroup.test
    // }
    this.requestRechargeCouponList()
  }
}
</script>

<style lang="less" scoped>
.cash-info-container {
  margin-left: 60px;
  .span-divider {
    display: inline-block;
    height: 16px;
    min-width: 150px;
    margin: 0;
  }
}
.wrapper .search-container .v-search-btn {
  .custom-container {
    float: right;
    span {
      color: #606266;
      margin-right: 10px;
      margin-left: 30px;
    }
    .el-input {
      float: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/webpc/CashierDesk/CashRechargeApp/CashRecharge.vue